import { SimpleLatLng } from "../Core";

const METERS_TO_FEET = 3.28084;
const GOOGLE_MAPS_TO_GOOGLE_EARTH_CONVERSION_FACTOR = 1.0024;

type computeLengthType = (
  path:
    | google.maps.LatLng[]
    | google.maps.LatLngLiteral[]
    | google.maps.MVCArray<google.maps.LatLng>,
  radius?: number,
) => number;

export function polygonPerimeter(
  computeLength: computeLengthType,
  geometry: SimpleLatLng[][],
  inFeet: boolean = false,
): number {
  let totalPerimeter = 0;

  // Calculate perimeter for all rings (outer boundary + holes)
  for (const ring of geometry) {
    // Create a closed path by adding the first point at the end if it's not already there
    const closedRing = [...ring];
    const firstPoint = ring[0];
    const lastPoint = ring[ring.length - 1];

    if (firstPoint.lat !== lastPoint.lat || firstPoint.lng !== lastPoint.lng) {
      closedRing.push(firstPoint);
    }

    const ringPerimeter = computeLength(closedRing);
    totalPerimeter += ringPerimeter;
  }

  if (inFeet) {
    const rawValue =
      (totalPerimeter * METERS_TO_FEET) /
      GOOGLE_MAPS_TO_GOOGLE_EARTH_CONVERSION_FACTOR;
    return Math.round(rawValue);
  }

  return Math.round(totalPerimeter);
}
